import { useEffect } from 'react';
import eventBus from 'src/common/eventBus';

export const useEventBus = (event, listener) => {
  useEffect(() => {
    // Subscribe to the event
    eventBus.on(event, listener);

    // Cleanup on unmount
    return () => {
      eventBus.off(event, listener);
    };
  }, [event, listener]);
}; 